import { Feedback } from '@playbooks/molecules/feedbacks';
import { Button } from '@playbooks/ui/components/button';
import { DialogFooter, DialogHeader } from '@playbooks/ui/components/dialog';

const ReferralFlowConfirm = ({ model, onClose, onView, onNext }) => {
	// Methods
	const onSubmit = e => {
		e.preventDefault();
		onClose();
	};

	// Render
	return (
		<form onSubmit={onSubmit}>
			<DialogHeader />
			<div className='flex-middle px-8 pb-8'>
				<Feedback
					layout='section'
					variant='success'
					icon='circle-check'
					title='Referral Accepted'
					text={`Nice work! We've processed your referral from ${model.name}. We'll apply the credit on your next invoice.`}
					className='w-full'
				/>
			</div>
			<DialogFooter className='block space-y-4'>
				<Button variant='outline' size='default' onClick={onClose} className='w-full'>
					Close
				</Button>
			</DialogFooter>
		</form>
	);
};
export { ReferralFlowConfirm };
